const INITIAL_STATE = {list: []}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'DATAESPECIAL_FETCHED':
            return { ...state, list: action.payload.data }
        case 'DATAESPECIAL_PAGE':
            return { ...state, paginaAtual: action.payload };
        default:
            return state
    }
}